// Globals
import { useEffect, useRef } from 'react';
import { draggable } from '@atlaskit/pragmatic-drag-and-drop/element/adapter';

// Components
import { StyledPhotoItem, StyledActionButton } from './ProductPhotosFieldStyles';
import { TrashDarkIcon, DragIcon } from '@/icons';
import { PhotoItem } from '../../helpers';
import { ImageWithPreview } from '@/components';

interface IProductPhotoItem {
  item: PhotoItem;
  index: number;
  onDelete: (item: PhotoItem) => void;
  isServerPhoto: boolean;
}

const ProductPhotoItem = ({ item, index, onDelete, isServerPhoto }: IProductPhotoItem) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const cleanup = draggable({
      element,
      getInitialData: () => ({ index }),
    });

    return () => cleanup();
  }, [index]);

  const getImageSrc = () => {
    return isServerPhoto ? item.originalUrl : URL.createObjectURL(item.originFileObj!);
  };

  return (
    <StyledPhotoItem ref={ref}>
      <ImageWithPreview src={getImageSrc()} />
      <StyledActionButton onClick={() => onDelete(item)}>
        <TrashDarkIcon />
      </StyledActionButton>
      <StyledActionButton $isDragButton={true}>
        <DragIcon />
      </StyledActionButton>
    </StyledPhotoItem>
  );
};

export default ProductPhotoItem;
